import { z } from 'zod';
import { testBookingRequestSchema } from '@vagusx/clients';
import { toIsoDate } from '@/lib/date-range';

/** The test-booking dialog's fields (ADR-293); the patient comes from the referral. */
export const testBookingFormSchema = testBookingRequestSchema.omit({ patientId: true }).extend({
  appointmentTypeId: z.string().uuid('Pick an appointment type'),
});
export type TestBookingFormValues = z.infer<typeof testBookingFormSchema>;

/** The next whole hour as `HH:mm`, so the form opens on a time that is still ahead. */
export function nextHour(now: Date = new Date()): string {
  const hour = (now.getHours() + 1) % 24;
  return `${String(hour).padStart(2, '0')}:00`;
}

/** What the dialog opens on, and resets to: today, on the hour, no type picked. */
export function testBookingDefaults(now: Date = new Date()): TestBookingFormValues {
  return { appointmentTypeId: '', date: toIsoDate(now), time: nextHour(now) };
}
